<h1>Publizierte Videoformate</h1>
<section class="article">
  <article>
    <div class="text">
      <p>
        Die veröffentlichte Video-Anleitung ist eine HTML5-Anwendung und muss
        mit einem Webbrowser abgespielt werden. HTML5 unterstützt dabei direkt
        die Darstellung von Videos in einer Webseite, dazu wird kein Player und
        kein PlugIn (z.B. Flash) benötigt. Allerdings beherrschen die
        verbreiteten Browser nicht alle die gleichen Video-Formate.
      </p>
      <p>
        Am weitesten verbreitet ist das Video-Format MP4 (H.264). Es wird von
        allen aktuellen Browsern unterstützt. Das MP4-Format ist allerdings ein
        lizenzrechtlich geschütztes Format. Einige Open-Source-Browser (auch
        ältere Versionen von Mozilla Firefox) unterstützen dieses Format deshalb
        nicht. Diese Browser greifen dann auf ein lizenzfreies Format wie WebM
        zurück.
      </p>
      <p>
        HTML5 ist so aufgebaut, dass eine Anwendung dem Browser Videos in
        mehreren Formaten zur Verfügung stellen kann. Der Browser sucht sich
        dann selbst das Format aus, welches er am besten unterstützt.
      </p>
      <p>
        video2manual ermöglicht es, die Videos in den beiden am weitesten
        verbreiteten Formaten zur Verfügung zu stellen. Wenn Sie nicht wissen,
        welche Browser bzw. Browser-Versionen von Ihren Anwendern verwendet
        werden, sollten Sie beide Formate bereitstellen. Die dabei erzeugte
        Datenmenge ist allerdings etwa doppelt so groß, als wenn Sie nur ein
        Video-Format nutzen. Außerdem dauert der Export der Daten deutlich
        länger. Bei einer Bereitstellung der Video-Anleitungen im Internet bzw.
        im Intranet ist das kein Problem, der Browser des Anwenders wird sich
        trotzdem nur die Videos herunterladen, die er aktuell benötigt. Der
        Speicherplatz auf dem Server ist normalerweise nicht der begrenzende
        Faktor.
      </p>
      <img class="screenshot" src="assets/publish.jpg" />
    </div>
    <a [routerLink]="['/blog']" class="call">Zurück zur Übersicht</a>
  </article>
</section>
